import Request from 'gd-request';

export default class ApiStripe {


    createPaymentIntention() {
        return new Request(this,'POST','stripe/payment-intention');
    }

    createCustomer() {
        return new Request(this,'POST','stripe/create-customer');
    }

    activateSubscription(stripeSubscriptionId, quantity) {
        return new Request(this,'POST','company/stripe/activate-subscription', {
            stripeSubscriptionId,
            quantity
        });
    }

    createSubscription(companyId, paymentMethodId, stripePlanId, quantity, discountCode, license) {
        return new Request(this,'POST','company/'+companyId+'/stripe/create-subscription', {
            paymentMethodId,
            stripePlanId,
            quantity,
            discountCode,
            license
        });
    }

}